var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M20.1666 11.0026C20.1666 16.0652 16.0626 20.1693 11 20.1693C5.93737 20.1693 1.83331 16.0652 1.83331 11.0026C1.83331 5.93999 5.93737 1.83594 11 1.83594C16.0626 1.83594 20.1666 5.93999 20.1666 11.0026Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3982 8.51849C14.7561 8.87647 14.7561 9.45687 14.3982 9.81485L10.7315 13.4815C10.3735 13.8395 9.79311 13.8395 9.43513 13.4815L7.6018 11.6482C7.24382 11.2902 7.24382 10.7098 7.6018 10.3518C7.95978 9.99384 8.54018 9.99384 8.89816 10.3518L10.0833 11.537L13.1018 8.51849C13.4598 8.1605 14.0402 8.1605 14.3982 8.51849Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8014352693a968d99e55c4195f9726ac.svg";
export { ForwardRef as ReactComponent };